// extracted by mini-css-extract-plugin
var _1 = "ServerErrorIndicator__main--Em3kp fontSize__errorIndicator--R8Mva CoreGeneral__robotoSlab--X8lgW";
export { _1 as "main" }
